import { render, staticRenderFns } from "./BaseContracts.vue?vue&type=template&id=65abcae0&scoped=true"
import script from "./BaseContracts.vue?vue&type=script&lang=js"
export * from "./BaseContracts.vue?vue&type=script&lang=js"
import style0 from "./BaseContracts.vue?vue&type=style&index=0&id=65abcae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abcae0",
  null
  
)

export default component.exports